export default __webpack_public_path__ + "static/quarter2-0588fc4e1545ed1da37053a332961b21.png";